// src/services/dashboard.service.js

import axios from 'axios';
import authHeader from './auth-header';

// Định nghĩa URL của 2 server
const API1 = `${process.env.REACT_APP_API_SERVER}/v7/server/status`;
const API2 = `${process.env.REACT_APP_API2_SERVER}/v7/server/status`;
const API3 = `${process.env.REACT_APP_API3_SERVER}/v7/server/status`;

const SERVICE1 = `${process.env.REACT_APP_SERVICE_SERVER}/server/status`;
const SERVICE2 = `${process.env.REACT_APP_SERVICE2_SERVER}/server/status`;

const DOWNLOAD = `${process.env.REACT_APP_DOWNLOAD_SERVER}/server/status`;

class DashboardService {
    // Gọi API lấy trạng thái server API 1
    getServerAPI_1() {
        return axios.get(API1, { headers: authHeader() });
    }

    // Gọi API lấy trạng thái server API 2
    getServerAPI_2() {
        return axios.get(API2, { headers: authHeader() });
    }

    // Gọi API lấy trạng thái server API 3
    getServerAPI_3() {
        return axios.get(API3, { headers: authHeader() });
    }

    // Gọi API lấy trạng thái server SERVICE 1
    getServerService_1() {
        return axios.get(SERVICE1, { headers: authHeader() });
    }

    // Gọi API lấy trạng thái server SERVICE 2
    getServerService_2() {
        return axios.get(SERVICE2, { headers: authHeader() });
    }

    // Gọi API lấy trạng thái server DOWNLOAD
    getServerDownload() {
        return axios.get(DOWNLOAD, { headers: authHeader() });
    }

    // Hoặc nếu muốn gọi cả 2 server trong 1 hàm
    getAllServers() {
        return Promise.all([
            axios.get(API1, { headers: authHeader() }),
            axios.get(API2, { headers: authHeader() }),
            axios.get(API3, { headers: authHeader() }),
            axios.get(SERVICE1, { headers: authHeader() }),
            axios.get(SERVICE2, { headers: authHeader() }),
            axios.get(DOWNLOAD, { headers: authHeader() })
        ]);
    }
}

export default new DashboardService();
